export default __webpack_public_path__ + "static/media/RewanLovelace.bee50410.png";